// extracted by mini-css-extract-plugin
export default {"secondBtn":"modal_secondBtn__6Z7w4","copy":"modal_copy__w4WHR"};